// extracted by mini-css-extract-plugin
export default {"container":"TextSection_container__qbDoD","title":"TextSection_title__Dx6K+","text":"TextSection_text__XHbIX","blur1":"TextSection_blur1__GlsMw","blur2":"TextSection_blur2__0kWdH"};